import { Box, Chip } from "@mui/material";
import { Datagrid, FunctionField, TextField, useGetList, useTranslate } from "react-admin";

import { LocationModeEnum } from "../generated/graphql";
import { useOrganizationContext } from "../hooks/useOrganizationContext";
import { SourceSystemChip } from "./fields/SourceSystemChip";
import { LocationChildrenExpand } from "./LocationChildrenExpand";

export const LocationDataGrid = () => {
  const translate = useTranslate();
  const { organizationId: selectedOrganizationId } = useOrganizationContext();

  const { data: allLocations } = useGetList("Location", {
    filter: { organizationId: selectedOrganizationId },
    pagination: { page: 1, perPage: 1000 },
  });

  const isRowExpandable = (record: { id: string }) => {
    if (!allLocations || !record?.id) return false;
    return allLocations.some(loc => loc.partOfId === record.id);
  };

  return (
    <Datagrid
      rowClick={"show"}
      bulkActionButtons={false}
      expand={<LocationChildrenExpand depth={1} />}
      isRowExpandable={isRowExpandable}
      sx={{
        "& .MuiTable-root": {
          tableLayout: "fixed",
        },
        "& .MuiTableBody-root .MuiTableCell-body[colspan]": {
          padding: 0,
        },
      }}
    >
      <FunctionField
        source="name"
        sortable={false}
        label="Name"
        sx={{ width: "25%" }}
        render={record => (
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            {record.name}
            {record.mode === LocationModeEnum.Kind && (
              <Chip label={translate("locationMode.KIND")} color="secondary" size="small" variant="outlined" />
            )}
          </Box>
        )}
      />
      <FunctionField
        label="Quelle"
        sortable={false}
        sx={{ width: "10%" }}
        render={record => <SourceSystemChip record={record} translatePrefix="Location.fields.sourceSystem" />}
      />
      <FunctionField
        source="type"
        sortable={false}
        label={"Typ"}
        sx={{ width: "14%" }}
        render={record => {
          if (!record.type) return "";
          return translate(`locationType.${record.type}`);
        }}
      />
      <TextField source="patientCount" sortable={false} label="Patient.countLabel" sx={{ width: "12%" }} />
      <TextField source="practitionerCount" sortable={false} label="Mitarbeiter" sx={{ width: "12%" }} />
      <TextField source="deviceCount" sortable={false} label="Geräte" sx={{ width: "12%" }} />
      <TextField source="externalId" sortable={false} label="External ID" sx={{ width: "15%" }} />
    </Datagrid>
  );
};
